/**
 * Build and trigger download of a report table as CSV (UTF-8 with BOM for Excel).
 */

export interface CsvColumn {
  key: string;
  label: string;
}

const escapeCsvCell = (value: string): string => {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

const cellToString = (raw: unknown): string => {
  if (raw === null || raw === undefined) return '';
  if (typeof raw === 'object') return JSON.stringify(raw);
  return String(raw);
};

export const buildReportTableCsv = (
  columns: CsvColumn[],
  rows: Record<string, unknown>[],
): string => {
  const header = columns.map((c) => escapeCsvCell(c.label)).join(',');
  const lines = rows.map((row) =>
    columns.map((col) => escapeCsvCell(cellToString(row[col.key]))).join(','),
  );
  return `\uFEFF${[header, ...lines].join('\r\n')}`;
};

export const downloadCsvFile = (csv: string, filename: string): void => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const sanitizeCsvFilename = (name: string): string => {
  const base = (name || 'report').replace(/[^\w.-]+/g, '_').replace(/_+/g, '_');
  const date = new Date().toISOString().slice(0, 10);
  return `${base}_${date}.csv`;
};

/** Server max rows per report-query (see ReportQueryBuilder). */
export const REPORT_TABLE_EXPORT_MAX_ROWS = 10_000;
